<template>
    <footer id="Footer" :style="styles">
        <div class="footer-container container">
            <div class="logos">
                <!-- <section class="section-1">{{ $t("Footer.Message1") }}</section> -->
                <section class="section-2">
                    <ProjectRoute to="http://www.tsinghua-gd.org/">
                        <img src="https://rdgta.cdn.cyagen.com/rddc/images/tsinghua.png" alt="tsinghua" />
                    </ProjectRoute>
                </section>
                <section class="section-3">
                    <ProjectRoute to="https://www.cyagen.com/">
                        <img src="@/assets/images/common/cyagen-logo.svg" alt="cyagen" />
                    </ProjectRoute>
                </section>
            </div>

            <div class="links">
                <!-- * 内部链接 -->
                <section class="section-1">
                    <ProjectRoute
                        v-for="(value, index) in vars.insides"
                        class="link text-[16px] leading-[32px] font-bold"
                        :key="index"
                        :to="value.link">
                        {{ value.name }}
                    </ProjectRoute>
                </section>

                <!-- * 网站信息 -->
                <section class="section-2">
                    <ui-tooltip class="footer-code" direction="top" align="center" :class-extra-name="css.code" @before-enter="">
                        <div class="footer-code-icon footer-wechat-code"></div>
                        <template #content>
                            <div :class="css.name">{{ $t("ContactUSWeChat") }}</div>
                            <img :class="css.image" src="@/assets/images/common/wechat-code.png" />
                            <div :class="css.copy" @click="Systems.copyText('rddc-support')">
                                <div :class="css.context" class="ellipsis">{{ $t("Wechat") }}: rddc-support</div>
                                <div :class="css.button">{{ $t("Copy") }}</div>
                            </div>
                        </template>
                    </ui-tooltip>

                    <ui-tooltip class="footer-code" direction="top" align="center" :class-extra-name="css.code">
                        <div class="footer-code-icon footer-bilibili-code" @click="methods.next"></div>
                        <template #content>
                            <div :class="css.name">{{ $t("ContactUSBilibili") }}</div>
                            <img :class="css.image" src="@/assets/images/common/bilibili-code.png" />
                            <div :class="css.copy" @click="Systems.copyText('https://space.bilibili.com/1553929661')">
                                <div :class="css.context" class="ellipsis">{{ $t("Link") }}: https://space.bilibili.com/1553929661</div>
                                <div :class="css.button">{{ $t("Copy") }}</div>
                            </div>
                        </template>
                    </ui-tooltip>

                    <div class="footer-info">
                        <p>{{ $t("ContactUs.Phone") }}</p>
                        <p>{{ $t("ContactUs.Email") }}</p>
                        <p>{{ $t("ContactUs.Website") }}</p>
                        <p>{{ $t("ContactUs.Address") }}</p>
                    </div>
                </section>

                <!-- * 友情链接 -->
                <section class="footer-relate-link">
                    <div class="relate-link-group items-start">
                        <div class="relate-link-label whitespace-nowrap">{{ $t("FriendshipLink") }}:</div>
                        <div class="relate-link-links">
                            <template v-for="(value, index) in vars.blogrolls" :key="index">
                                <div class="division" v-if="index > 0"></div>
                                <ProjectRoute class="link" :to="value.link"> {{ value.name }} </ProjectRoute>
                            </template>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="footer-record">
            <div class="container">
                <div class="footer-record-info">
                    <span class="footer-record-context">{{ $t("Footer.Message2") }}</span>
                    <template v-if="$i18n.locale == 'zh'">
                        <img class="footer-record-emblem" src="https://rdgta.cdn.cyagen.com/rddc/images/emblem.png" alt="emblem" />
                        <span class="footer-record-context">{{ $t("Footer.Message3") }}</span>
                    </template>
                </div>

                <div class="footer-return-top" @click="methods.return">
                    <span>{{ $t("ReturnTop") }}</span>
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/return-top.png" alt="Top" />
                </div>
            </div>
        </div>
    </footer>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 公共函数
import { Systems } from "@/assets/js";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const define = defineProps({ top: { type: Number }, isTop: { type: Boolean, default: false } });
const emits = defineEmits(["returnTop"]);

//* 组合函数
const { vars, methods, computeds } = useComposable(define, emits);
const { styles } = computeds;
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
